import { styled } from '@mui/material';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Button from '@Components/Button/Button';
import { selectedAnalysisEntityState } from '@Data/qualityControl/Reducer';
import Styles from '../../QualityControlBlock.scss';
import {
    ConfirmDialog,
    ConfirmQcDialogType,
    IConfirmDialogButtonProps,
} from './ConfirmDialog';

export enum InspectionTargetOutcome {
    NOT_MET, // target not met
    YIELD_FAIL, // target met, yield fail
    YIELD_PASS, // target met, yield pass
}

interface IQcBlockFooterProps {
    onCancel: () => void;
    onFinish: () => void;
    onNext: () => void;
}

const StyledContainer = styled('div')`
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: ${Styles.reworkAreaBottomRowHeight};
    padding: 3px ${Styles.reworkAreaHorizontalPadding};

    div {
        display: flex;
        gap: 1rem;
    }
`;

export const QcBlockFooter = (props: IQcBlockFooterProps) => {
    const selectedAnalysisEntity = useSelector(selectedAnalysisEntityState);

    const [isConfirmDialogOpen, setIsConfirmDialogOpen] =
        useState<boolean>(false);
    const [confirmDialogType, setConfirmDialogType] =
        useState<ConfirmQcDialogType>(null);
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

    const handleConfirmDialog = async () => {
        if (confirmDialogType === ConfirmQcDialogType.QUIT) {
            props.onCancel();
        }
        setIsConfirmDialogOpen(false);
    };

    const handleOpenFinishDialog = (isFinish: boolean) => {
        const dType = isFinish
            ? ConfirmQcDialogType.COMPLETE
            : ConfirmQcDialogType.QUIT;
        setConfirmDialogType(dType);
        setIsConfirmDialogOpen(true);
    };

    const areAnyReworks =
        selectedAnalysisEntity?.reworkReasons &&
        selectedAnalysisEntity?.reworkReasons.length > 0;

    const nextText = areAnyReworks ? 'Teleport' : 'Pass';

    return (
        <>
            <StyledContainer>
                <div>
                    <Button
                        color="black"
                        onClick={() => handleOpenFinishDialog(false)}
                    >
                        Quit
                    </Button>
                    <Button color={'red'} onClick={props.onFinish}>
                        Finish
                    </Button>
                </div>
                <Button
                    color={areAnyReworks ? 'blue' : 'green'}
                    onClick={props.onNext}
                >
                    {nextText}
                </Button>
            </StyledContainer>
            <ConfirmDialog
                isOpen={isConfirmDialogOpen}
                onClose={() => setIsConfirmDialogOpen(false)}
                dialogType={confirmDialogType}
                onConfirm={handleConfirmDialog}
                isSubmitting={isSubmitting}
            />
        </>
    );
};
